// Application route constants
export const ROUTES = {
  HOME: '/',
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER: '/auth/register',
    FORGOT_PASSWORD: '/auth/forgot-password',
  },
  DASHBOARD: {
    HOME: '/dashboard',
    IMEI_CHECK: '/dashboard/imei-check',
    ORDERS: '/dashboard/orders',
    ADVANCED_HISTORY: '/dashboard/advanced-history',
    INVOICES: '/dashboard/invoices',
    PROFILE: '/dashboard/profile',
    CONTACT: '/dashboard/contact',
  },
  ADMIN: {
    HOME: '/admin/dashboard',
    USER_MANAGEMENT: '/admin/users',
    SUPPORT: '/admin/support',
    ORDERS: '/admin/orders',
    INVOICES: '/admin/invoices',
    SUBSCRIPTIONS: '/admin/subscriptions',
    CREDITS: '/admin/credits',
  },
  IMEI: {
    CHECK: '/imei/check',
    RESULTS: '/imei/results',
  },
  LEGAL: {
    PRIVACY: '/legal/privacy',
    TERMS: '/legal/terms',
    ABOUT: '/legal/about',
  },
};

// Navigation menu items
export const NAVIGATION_ITEMS = [
  { label: 'Home', href: '#home', external: false },
  {
    label: 'FREE IMEI CHECK',
    href: '#imei-check',
    external: false,
    hasDropdown: true,
  },
  { label: 'Pricing', href: '#pricing', external: false },
  { label: 'BLOG', href: '#blog', external: false },
  { label: 'Contact', href: '#contact', external: false },
];

// External links
export const EXTERNAL_LINKS = {
  SOCIAL: {
    FACEBOOK: 'https://facebook.com/imeicheck',
    TWITTER: 'https://twitter.com/imeicheck',
    YOUTUBE: 'https://youtube.com/imeicheck',
    INSTAGRAM: 'https://instagram.com/imeicheck',
  },
  SUPPORT: {
    WHATSAPP: 'https://wa.me/1234567890',
    SKYPE: 'skype:imeicheck',
    EMAIL: 'mailto:support@imeicheck.com',
  },
};
